/**
 * Email subscription handler.
 */
jQuery(document).ready(function ($) {

    const isValidEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    $('.email-subscribe-form').submit(function (e) {
        e.preventDefault();

        const form = $(this);
        const btnSubmit = e.target.querySelector('button[type="submit"]');
        const spinner = btnSubmit.querySelector('.vendora-spinner-border');

        let email = $(this).find('input[name="email"]').val();

        if (!isValidEmail(email)) {
            toast.error('Please enter valid email address');
            return;
        }

        const data = {
            'products-nonce': vendoraObject.nonce_value,
            action: 'vendora_email_subscription',
            email: email
        }

        $.ajax({
            url: vendoraObject.ajax_url,
            type: 'POST',
            data: data,
            beforeSend: function () {
                btnSubmit.setAttribute('disabled', 'disabled');
                spinner.classList.remove('vendora-d-none');
            },
            success: function (res) {
                if (res.success) {
                    toast.success(res.data);
                    form[0].reset();
                } else {
                    toast.error(res.data);
                }
            },
            error: function (err) {
                console.log(err)
            },
            complete: function () {
                btnSubmit.removeAttribute('disabled');
                spinner.classList.add('vendora-d-none');
            }
        })
    })
})